import AppFooterContentWidget from '../../widgets/app-footer-content-widget';
import CasinoActiveRacesWidget from '../../widgets/casino-active-races-widget';
import CasinoCompletedRacesWidget from '../../widgets/casino-completed-races-widget';
import CasinoGameGridWidget from '../../widgets/casino-game-grid-widget';
import CasinoGameInfoWidget from '../../widgets/casino-game-info-widget';
import CasinoGameSliderWidget from '../../widgets/casino-game-slider-widget';
import CasinoGameWidget from '../../widgets/casino-game-widget';
import CasinoMosaicWidget from '../../widgets/casino-mosaic-widget';
import CasinoMyGamesWidget from '../../widgets/casino-my-games-widget';
import CasinoMyRewardsWidget from '../../widgets/casino-my-rewards-widget';
import CasinoPlayerGamesWidget from '../../widgets/casino-player-games-widget';
import CasinoRacesWidget from '../../widgets/casino-races-widget';
import CasinoSecondaryNavigation from '../../widgets/casino-secondary-navigation';
import CasinoTopGamesWidget from '../../widgets/casino-top-games-widget';
import CasinoUpcomingRacesWidget from '../../widgets/casino-upcoming-races-widget';
import CMSNavigationWidget from '../../widgets/cms-navigation-widget';
import CMSPageWidget from '../../widgets/cms-page-widget';
import CrmDualZoneWidget from '../../widgets/crm-dual-zone-widget';
import CrmWidget from '../../widgets/crm-widget';
import FooterWidget from '../../widgets/footer-widget';
import HeaderWidget from '../../widgets/header-widget';
import HelpCenterArticleWidget from '../../widgets/help-center-article-widget';
import HelpCenterCategoryWidget from '../../widgets/help-center-category-widget';
import HelpCenterHomeWidget from '../../widgets/help-center-home-widget';
import HelpCenterSearchWidget from '../../widgets/help-center-search-widget';
import NavWidget from '../../widgets/nav-widget';
import PokerHomeGamesWidget from '../../widgets/poker-home-games-widget';
import PokerWidget from '../../widgets/poker-widget';
import SportsBetSlipWidget from '../../widgets/sports-bet-slip-widget';
import SportsBreadcrumbsWidget from '../../widgets/sports-breadcrumbs-widget';
import SportsCmsBannerWidget from '../../widgets/sports-cms-banner-widget';
import SportsCompetitionEventsWidget from '../../widgets/sports-competition-events-widget';
import SportsCompetitionOutrightsWidget from '../../widgets/sports-competition-outrights-widget';
import SportsCompetitionsResultsWidget from '../../widgets/sports-competitions-results-widget';
import SportsCompetitionsWidget from '../../widgets/sports-competitions-widget';
import SportsCouponEventsWidget from '../../widgets/sports-coupon-events-widget';
import SportsCouponsWidget from '../../widgets/sports-coupons-widget';
import SportsEventInfoWidget from '../../widgets/sports-event-info-widget';
import SportsEventResultsWidget from '../../widgets/sports-event-results-widget';
import SportsEventTypeInfoWidget from '../../widgets/sports-event-type-info-widget';
import SportsFeaturedFiltersWidget from '../../widgets/sports-featured-filters-widget';
import SportsFeaturedWidget from '../../widgets/sports-featured-widget';
import SportsGolfMatchesWidget from '../../widgets/sports-golf-matches-widget';
import SportsHistoricalBetsWidget from '../../widgets/sports-historical-bets-widget';
import SportsInPlayEventsWidget from '../../widgets/sports-in-play-events-widget';
import SportsMarketsWidget from '../../widgets/sports-markets-widget';
import SportsMatchFilteringWidget from '../../widgets/sports-match-filtering-widget';
import SportsMenuWidget from '../../widgets/sports-menu-widget';
import SportsMyBetsWidget from '../../widgets/sports-my-bets-widget';
import SportsPageNotFoundWidget from '../../widgets/sports-page-not-found-widget';
import SportsPromotionDetailsWidget from '../../widgets/sports-promotion-details-widget';
import SportsPromotionGridWidget from '../../widgets/sports-promotion-grid-widget';
import SportsPromotionWidget from '../../widgets/sports-promotion-widget';
import SportsQuickLinksWidget from '../../widgets/sports-quick-links-widget';
import SportsSelfExcludedInfoWidget from '../../widgets/sports-self-excluded-info-widget';
import SportsSettingsWidget from '../../widgets/sports-settings-widget';
import SportsSportInPlayEventsWidget from '../../widgets/sports-sport-in-play-events-widget';
import StarsCoinWidget from '../../widgets/stars-coin-widget';
import WinningMomentsWidget from '../../widgets/winning-moments-widget';

export default {
  AppFooterContentWidget,
  CasinoActiveRacesWidget,
  CasinoCompletedRacesWidget,
  CasinoSecondaryNavigation,
  CasinoGameGridWidget,
  CasinoGameInfoWidget,
  CasinoGameSliderWidget,
  CasinoGameWidget,
  CasinoMosaicWidget,
  CasinoMyGamesWidget,
  CasinoMyRewardsWidget,
  CasinoPlayerGamesWidget,
  CasinoRacesWidget,
  CasinoTopGamesWidget,
  CasinoUpcomingRacesWidget,
  CMSNavigationWidget,
  CMSPageWidget,
  CrmDualZoneWidget,
  CrmWidget,
  FooterWidget,
  HeaderWidget,
  HelpCenterCategoryWidget,
  HelpCenterSearchWidget,
  HelpCenterArticleWidget,
  HelpCenterHomeWidget,
  NavWidget,
  PokerHomeGamesWidget,
  PokerWidget,
  SportsBetSlipWidget,
  SportsBreadcrumbsWidget,
  SportsCmsBannerWidget,
  SportsCompetitionEventsWidget,
  SportsCompetitionOutrightsWidget,
  SportsCompetitionsResultsWidget,
  SportsCompetitionsWidget,
  SportsCouponEventsWidget,
  SportsCouponsWidget,
  SportsEventInfoWidget,
  SportsEventResultsWidget,
  SportsEventTypeInfoWidget,
  SportsFeaturedFiltersWidget,
  SportsFeaturedWidget,
  SportsGolfMatchesWidget,
  SportsHistoricalBetsWidget,
  SportsInPlayEventsWidget,
  SportsMarketsWidget,
  SportsMatchFilteringWidget,
  SportsMenuWidget,
  SportsMyBetsWidget,
  SportsPageNotFoundWidget,
  SportsPromotionDetailsWidget,
  SportsPromotionGridWidget,
  SportsPromotionWidget,
  SportsQuickLinksWidget,
  SportsSelfExcludedInfoWidget,
  SportsSettingsWidget,
  SportsSportInPlayEventsWidget,
  StarsCoinWidget,
  WinningMomentsWidget
};
